import { canUseDOM } from '@ps/web-core-utils';
import type { LottieRefCurrentProps } from 'lottie-react';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useLottieLoader } from '@swf/poker';

import watchGamesAnimation from '../../../assets/animations/watch-games.json';
import { usePokerSpinAndGoWidget } from '../../../model';

export const Icon: React.FC<{ isHovered?: boolean }> = ({ isHovered }) => {
  const { widgetSelect } = usePokerSpinAndGoWidget();
  const tickerMessage = useSelector(widgetSelect.tickerMessage);
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const { LottieComponent } = useLottieLoader();

  useEffect(() => {
    if (!lottieRef.current || !tickerMessage) return;

    lottieRef.current.playSegments(
      [
        [30, 80],
        [80, 140],
        [80, 140],
        [80, 140],
        [80, 140],
        [140, 0]
      ],
      true
    );
  }, [tickerMessage]);

  useEffect(() => {
    if (tickerMessage || !lottieRef.current || isHovered === undefined) return;

    const playOptions: [number, number] = isHovered ? [30, 60] : [60, 0];

    lottieRef.current.playSegments([playOptions], true);
  }, [tickerMessage, isHovered]);

  if (!canUseDOM || !LottieComponent) {
    return null;
  }

  return (
    <LottieComponent
      lottieRef={lottieRef}
      animationData={watchGamesAnimation}
      loop={false}
      autoplay={false}
    />
  );
};
